import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CONSTANTS } from "app/constants";
import { LeftMenuItem } from "app/models";

@Component({
    selector: 'admin-mobile-menu',
    templateUrl: './admin-mobile-menu.html',
    styleUrls: ['./admin-mobile-menu.scss'],
})
export class AdminMobileMenu implements OnInit{
    menuItems: LeftMenuItem[] = [];
    
    constructor(private router: Router) {
        this.buildMenuItems();
    }

    ngOnInit(): void {
        
    }

    goTo(menuItem: LeftMenuItem) {
        this.router.navigate([menuItem.route]);
    }

    private buildMenuItems() {
        this.menuItems = [];

        this.menuItems.push(this.buildMenuItem("Статистика", CONSTANTS.routes.admin.dashboard, false));
        this.menuItems.push(this.buildMenuItem("Игровые дни", CONSTANTS.routes.admin.matchDays, false));
        this.menuItems.push(this.buildMenuItem("Еврокубки", CONSTANTS.routes.admin.euroCup, false));
        this.menuItems.push(this.buildMenuItem("Пользователи", CONSTANTS.routes.admin.euroCup, false));
    }

    private buildMenuItem(label: string, route: string, isSelected: boolean): LeftMenuItem {
        let result =  new LeftMenuItem();

        result.label = label;
        result.route = route;
        result.isSelected = isSelected;

        return result;
    }

}